import React from "react";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyledTabs, StyledTab, TabsHeader } from "@components/Tabs/Tabs";
import { SecuritiesChartType } from "./types";

interface ChartTypeTabsProps {
  chartType: SecuritiesChartType;
  onChartTypeChange?: (value: SecuritiesChartType) => void;
}

export const ChartTypeTabs = ({
  chartType,
  onChartTypeChange,
}: ChartTypeTabsProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newValue: SecuritiesChartType
  ) => {
    if (onChartTypeChange) {
      onChartTypeChange(newValue);
    }
  };

  return (
    <TabsHeader centered={false}>
      <StyledTabs value={chartType} onChange={handleTabChange}>
        <StyledTab
          label={t("securitiesChart.typeSwitcher.valuation")}
          value="valuation"
          style={{
            color:
              chartType === "valuation"
                ? theme.palette.primary.main
                : theme.palette.text.secondary,
          }}
        />
        <StyledTab
          label={t("securitiesChart.typeSwitcher.performance")}
          value="performance"
          style={{
            color:
              chartType === "performance"
                ? theme.palette.primary.main
                : theme.palette.text.secondary,
          }}
        />
      </StyledTabs>
    </TabsHeader>
  );
};
